import React from 'react';
import { useRootTheme } from './hooks';
import { ThemeProvider } from './themeProvider';
export function ThemeColorProvider(props) {
    const { children, scheme, tone } = props;
    const root = useRootTheme();
    return (React.createElement(ThemeProvider, { scheme: scheme || root.scheme, theme: root.theme, tone: tone }, children));
}
//# sourceMappingURL=themeColorProvider.js.map